import instance from "@/services/api";

export const bimCategoryParamsAPI = {
  async getParams(bim_category_id) {
    return await instance().get(`/handbook/bim_category_params/${bim_category_id}/params/`).then(res => res?.data)
  },
  async getAllParams() {
    return await instance().get('/handbook/bim_category_params/params/all/').then(res => res?.data)
  },
  async saveParam(data) {
    return await instance().post('/handbook/bim_category_params/params/save/', data).then(res => res?.data)
  },
  async deleteParam(bim_category_param_id) {
    return await instance().delete(`/handbook/bim_category_params/params/${bim_category_param_id}/delete/`).then(res => res?.data)
  }
}
